// const cloudUrl = 'http://cloud.yunhzh.com/';
const cloudUrl = 'https://cloud.yzdli.com/'
const cloudDataUrl = 'https://www.yzdli.com/cloud-data'

// 3.3 先更新参展商的, 其他的后续更新
//
/**
 * 会员后台菜单配置
 * @key 是选中属性,$route.name
 */
// 参观商菜单
export const visitor = [
  {
    classIcon: 'iconicon_left_home',
    href: '/visitor',
    key: 'visitor',
    text: '首页',
  },
  {
    href: '/visitor/data',
    classIcon: 'iconicon_left_qiyeyz',
    key: 'visitor-data',
    text: '云展访问数据',
  },
  {
    href: '/visitor/card',
    classIcon: 'iconicon_left_wodemp',
    key: 'visitor-card',
    text: '我的名片',
  },
  {
    classIcon: 'iconicon_left_kehugl',
    href: '/visitor/cces/count/myCustomerDatabase',
    key: 'visitor-cces-count-myCustomerDatabase',
    text: '我的客户库',
  },
  // {
  //   href: '/visitor/cloudExhibit',
  //   classIcon: 'iconyunszl',
  //   key: 'visitor-cloudExhibit',
  //   text: '云上展览系统',
  //   children: [
  //     {
  //       specialState: 'isShowUpdate',
  //       key: 'visitor-myExhibit-exhibitSignup',
  //       text: '参展报名',
  //     },
  //   ],
  // },
  {
    href: '/visitor/dataMarketing',
    classIcon: 'iconicon_left_dashuj',
    key: 'visitor-dataMarketing',
    text: '大数据获客',
    children: [
      {
        href: '/visitor/dataMarketing/aiCall',
        key: 'visitor-dataMarketing-aiCall',
        text: '外呼呼叫',
        children: [
          {
            text: '话术管理',
            href: '/visitor/dataMarketing/aiCall/words',
            key: 'visitor-dataMarketing-aiCall-words',
          },
          {
            text: '外呼任务管理',
            href: '/visitor/dataMarketing/aiCall/task',
            key: 'visitor-dataMarketing-aiCall-task',
          },
          {
            text: '呼叫记录',
            href: '/visitor/dataMarketing/aiCall/record',
            key: 'visitor-dataMarketing-aiCall-record',
          },
        ],
      },
      {
        href: '/visitor/dataMarketing/preciseInvitation/china',
        key: 'visitor-dataMarketing-preciseInvitation-home-china',
        text: '短信邀约',
      },
      {
        href: '/visitor/dataMarketing/preciseInvitation/international',
        key: 'visitor-dataMarketing-preciseInvitation-home-international',
        text: '邮件邀约',
      },
      // {
      //   href: '/visitor/dataMarketing/addressBook',
      //   key: 'visitor-dataMarketing-addressBook',
      //   text: '客户库',
      // },
      // {
      //   href: '/visitor/dataMarketing/cloudData',
      //   key: 'visitor-dataMarketing-cloudData',
      //   text: '云数据'
      // }
    ],
  },
  {
    href: '/visitor/bidding',
    classIcon: 'iconicon_left_zhaoshang',
    key: 'visitor-bidding',
    text: '招商招标系统',
    children: [
      {
        href: '/visitor/bidding',
        key: 'visitor-bidding',
        text: '云招标管理',
      },
      // {
      //   href: '/visitor',
      //   specialState: 'disable',
      //   key: 'visitor-bidding-addressBook',
      //   text: '云供应管理',
      //   subText: '(敬请期待)'
      // },
    ],
  },
  {
    href: '/visitor/procurement/cloud',
    classIcon: 'iconicon_left_caigouxt',
    key: 'visitor-procurement',
    text: '采购系统',
    children: [
      {
        href: '/visitor/procurement/cloud',
        key: 'visitor-procurement-cloud',
        text: '云采购',
      },
      {
        href: '/visitor/procurement/self',
        key: 'visitor-procurement-self',
        text: '我的采购单',
      },
    ],
  },
  {
    href: '/visitor/myCoupons',
    classIcon: 'iconicon_youhq',
    key: 'visitor-my-coupons',
    text: '我的优惠券',
  },
  {
    classIcon: 'iconcustomization',
    key: 'visitor-poster',
    text: '我的云设计',
    children: [
      {
        key: 'visitor-poster-poster',
        text: '我的海报',
      },
    ],
  },
  {
    // href: '/visitor/myExhibit',
    classIcon: 'iconMoneymanagement',
    key: 'visitor-myExhibit',
    text: '我的展览',
    children: [
      {
        // specialState: 'isShowUpdate',
        href: '/visitor/myExhibit/visitSignup',
        key: 'visitor-myExhibit-exhibitSignup',
        text: '参观报名',
      },
    ],
  },
  {
    // href: '/visitor/myMeeting',
    classIcon: 'icontraining',
    key: 'visitor-myMeeting',
    text: '我的会议',
    children: [
      {
        href: '/visitor/myMeeting/join',
        key: 'visitor-myMeeting-join',
        text: '参加报名',
      },
      {
        href: '/visitor/myMeeting/sponsor',
        key: 'visitor-myMeeting-sponsor',
        text: '会议赞助',
      },
    ],
  },
  {
    href: '/visitor/keep',
    classIcon: 'iconicon_left_wodsc',
    key: 'visitor-keep',
    text: '我的收藏',
  },
  {
    href: '/visitor/notifications',
    classIcon: 'iconicon_left_xiaoxizx',
    key: 'visitor-notifications',
    text: '消息中心',
  },
  {
    href: '/visitor/companiesToWatch',
    classIcon: 'iconicon_left_wodsc',
    key: 'visitor-companiesToWatch',
    text: '关注的企业',
  },
  {
    href: '/visitor/finance',
    classIcon: 'iconicon_left_caiwuzx',
    key: 'visitor-finance',
    text: '财务中心',
    children: [
      {
        href: '/visitor/account',
        key: 'visitor-account',
        text: '我的钱包',
      },
      {
        href: '/visitor/order',
        key: 'visitor-order',
        text: '订单管理',
      },
    ],
  },
  {
    href: '/visitor/basicInfo',
    classIcon: 'iconicon_left_zhanghaosz',
    key: 'visitor-basicInfo',
    text: '账号设置',
    children: [
      {
        href: '/visitor/basicInfo',
        key: 'visitor-basicInfo',
        text: '基本资料',
      },
      // {
      //   href: '/visitor/basicInfo/myInvite',
      //   key: 'visitor-basicInfo-myInvite',
      //   text: '我的邀请',
      // },
    ],
  },
]

// 主办商菜单
export const organizer = [
  {
    classIcon: 'iconicon_left_home',
    href: '/organizer',
    key: 'organizer',
    text: '首页',
  },
  {
    href: '/organizer/cces',
    classIcon: 'iconicon_left_qiyeyz',
    key: 'organizer-cces',
    text: '企业云展系统',
    children: [
      {
        href: '/organizer/cces/cloud',
        key: 'organizer-cces-cloud',
        text: '我的云企业',
      },
      {
        href: '/organizer/cces/roaming',
        key: 'organizer-cces-roaming',
        text: '企业漫游',
      },
      // {
      //   href: '/organizer/product',
      //   key: 'organizer-product',
      //   text: '产品服务',
      // },
      {
        text: '展览管理',
        href: '/organizer/exhibition',
        key: 'organizer-exhibition',
        clickable: true,
        isShow: true,
      },
      {
        href: '/organizer/cces/dynamic',
        key: 'organizer-cces-dynamic',
        text: '我的企业动态',
      },
      {
        attr: cloudUrl,
        key: 'organizer-cloudDisk',
        text: '企业资料库',
      },
      // 云展访问数据
      {
        href: '/organizer/data',
        key: 'organizer-data',
        text: '云展访问数据',
      },
    ],
  },
  // Ai智能名片, 下面有我的名片, 通讯录
  {
    text: 'AI智能名片',
    classIcon: 'iconicon_left_wodemp',
    children: [
      {
        href: '/organizer/card',
        key: 'organizer-card',
        text: '我的名片',
      },
      {
        href: '/organizer/cardAddressBook',
        key: 'organizer-cardAddressBook',
        text: '通讯录',
      },
    ],
  },
  // 客户邀约模块, 原本叫大数据获客
  {
    href: '/organizer/dataMarketing',
    classIcon: 'iconicon_left_dashuj',
    key: 'organizer-dataMarketing',
    text: '客户邀约',
    children: [
      {
        href: '/organizer/dataMarketing/aiCall',
        key: 'organizer-dataMarketing-aiCall',
        text: '外呼呼叫',
        children: [
          {
            text: '智能任务',
            href: '/organizer/dataMarketing/aiCall',
            key: 'organizer-dataMarketing-aiCall',
          },
          {
            text: '话术管理',
            href: '/organizer/dataMarketing/aiCall/words',
            key: 'organizer-dataMarketing-aiCall-words',
          },
          {
            text: '外呼任务管理',
            href: '/organizer/dataMarketing/aiCall/task',
            key: 'organizer-dataMarketing-aiCall-task',
          },
          {
            text: '呼叫记录',
            href: '/organizer/dataMarketing/aiCall/record',
            key: 'organizer-dataMarketing-aiCall-record',
          },
        ],
      },
      {
        href: '/organizer/dataMarketing/preciseInvitation/china',
        key: 'organizer-dataMarketing-preciseInvitation-home-china',
        text: '短信邀约',
        children: [
          // 邀约模板, 邀约记录, 链接管理
          {
            href: '/organizer/dataMarketing/preciseInvitation/template/china',
            key: 'organizer-dataMarketing-preciseInvitation-home-china',
            text: '邀约模板',
          },
          {
            href: '/organizer/dataMarketing/preciseInvitation/record/china',
            key: 'organizer-dataMarketing-preciseInvitation-home-china-record',
            text: '邀约记录',
          },
          // {
          //   href: '/organizer/dataMarketing/preciseInvitation/link/china',
          //   key: 'organizer-dataMarketing-preciseInvitation-home-china-link',
          //   text: '链接管理',
          // },
        ],
      },
      {
        href: '/organizer/dataMarketing/preciseInvitation/international',
        key: 'organizer-dataMarketing-preciseInvitation-home-international',
        text: '邮件邀约',
        children: [
          // 邀约模板, 邀约记录, 链接管理
          {
            href: '/organizer/dataMarketing/preciseInvitation/template/international',
            key: 'organizer-dataMarketing-preciseInvitation-home-international',
            text: '邀约模板',
          },
          {
            href: '/organizer/dataMarketing/preciseInvitation/record/international',
            key: 'organizer-dataMarketing-preciseInvitation-home-international-record',
            text: '邀约记录',
          },
          // {
          //   href: '/organizer/dataMarketing/preciseInvitation/link/international',
          //   key: 'organizer-dataMarketing-preciseInvitation-home-international-link',
          //   text: '链接管理',
          // },
        ],
      },
      // {
      //   href: '/organizer/dataMarketing/invite',
      //   key: 'organizer-dataMarketing-invite',
      //   text: '精准邀约'
      // },
      // {
      //   href: '/organizer/dataMarketing/addressBook',
      //   key: 'organizer-dataMarketing-addressBook',
      //   text: '客户库',
      // },
      // {
      //   href: '/organizer/dataMarketing/cloudData',
      //   key: 'organizer-dataMarketing-cloudData',
      //   text: '云数据'
      // }
    ],
  },
  {
    classIcon: 'iconicon_left_kehugl',
    key: 'organizer-customerManagement',
    text: '客户管理系统',
    children: [
      // {
      //   href: '/organizer/cces/count/subAccount',
      //   key: 'organizer-cces-count-subAccount',
      //   text: '企业数据',
      // },
      {
        href: '/organizer/cces/count/customerDatabase',
        key: 'organizer-cces-count-customerDatabase',
        text: '企业客户库',
      },
      {
        href: '/organizer/cces/count/myCustomerDatabase',
        key: 'organizer-cces-count-myCustomerDatabase',
        text: '我的客户库',
      },
      {
        attr: cloudDataUrl,
        key: 'organizer-cloudData',
        text: '云数据',
      },
      // {
      //   href: '/organizer/data',
      //   key: 'organizer-data',
      //   text: '我的客户数据',
      // },
      // {
    ],
  },
  // 业务中心, 包括招商招标系统, 采购系统, 云上展览系统, 获客工具
  {
    icon: 'block',
    key: 'organizer-businessCenter',
    text: '业务中心',
    children: [
      {
        href: '/organizer/bidding',
        key: 'organizer-bidding',
        text: '招商招标系统',
        children: [
          {
            href: '/organizer/bidding',
            key: 'organizer-bidding',
            text: '云招标管理',
          },
          {
            href: '/organizer/merchants',
            key: 'organizer-merchants',
            text: '云招商管理',
          },
        ],
      },
      {
        href: '/organizer/procurement/cloud',
        classIcon: 'iconicon_left_caigouxt',
        key: 'organizer-procurement',
        text: '采购系统',
        children: [
          {
            href: '/organizer/procurement/cloud/opportunities',
            key: 'organizer-procurement-opportunities',
            text: '采购商机',
          },
          {
            href: '/organizer/procurement/cloud',
            key: 'organizer-procurement-cloud',
            text: '我的采购',
          },
          {
            href: '/organizer/procurement/self',
            key: 'organizer-procurement-self',
            text: '我的采购单',
          },
        ],
      },
      // {
      //   // href: '/organizer/cloudExhibit',
      //   key: 'organizer-cloudExhibit',
      //   text: '云上展览系统',
      //   children: [
      //     {
      //       href: '/organizer/myExhibit/exhibitSignup',
      //       key: 'organizer-myExhibit-exhibitSignup',
      //       text: '参展报名',
      //     },
      //   ],
      // },
    ],
  },
  // 获客工具, 包括云头条,云优惠,我的直播,我的展览,我的会议
  {
    classIcon: 'iconicon_left_huoke',
    key: 'organizer-customerTool',
    text: '获客工具',
    children: [
      {
        href: '/organizer/cces/recruit',
        key: 'organizer-cces-recruit',
        text: '云招聘',
      },
      {
        href: '/organizer/information',
        key: 'organizer-information',
        text: '云头条',
      },
      {
        href: '/organizer/cces/offers',
        key: 'organizer-cces-offers',
        text: '云优惠',
      },
      // {
      //   href: '/organizer/myCoupons',
      //   key: 'organizer-my-coupons',
      //   text: '我的优惠券',
      // },
      {
        href: '/organizer/poster/poster',
        icon: 'picture',
        key: 'organizer-poster-poster',
        text: '云海报',
      },
      {
        href: '/organizer/myLive',
        icon: 'play-circle',
        key: 'organizer-myLive',
        text: '我的直播',
      },
      {
        // href: '/organizer/myExhibit',
        icon: 'appstore',
        key: 'organizer-myExhibit',
        text: '我的展览',
        children: [
          {
            // specialState: 'isShowUpdate',
            href: '/organizer/myExhibit/visitSignup',
            key: 'organizer-myExhibit-visitSignup',
            text: '参观报名',
          },
          {
            // specialState: 'isShowUpdate',
            href: '/organizer/myExhibit/buildSignup',
            key: 'organizer-myExhibit-buildSignup',
            text: '展厅搭建报名',
          },
        ],
      },
      {
        // href: '/organizer/myMeeting',
        icon: 'laptop',
        key: 'organizer-myMeeting',
        text: '我的会议',
        children: [
          {
            // specialState: 'isShowUpdate',
            href: '/organizer/myMeeting/join',
            key: 'organizer-myMeeting-join',
            text: '参加报名',
          },
          {
            // specialState: 'isShowUpdate',
            href: '/organizer/myMeeting/sponsor',
            key: 'organizer-myMeeting-sponsor',
            text: '会议赞助',
          },
          {
            href: '/organizer/Meeting',
            key: 'organizer-message',
            text: '会议管理',
          },
        ],
      },
    ],
  },
  // 员工管理, 包括子账号管理和员工分享数据
  {
    icon: 'solution',
    key: 'organizer-employeeManagement',
    text: '员工管理',
    children: [
      {
        href: '/organizer/ram',
        key: 'organizer-ram',
        text: '子账号管理',
      },
      {
        href: '/organizer/cces/count/staffManage',
        key: 'organizer-cces-count-staffManage',
        text: '员工分享数据',
      },
    ],
  },
  // 个人中心, 包括 我的优惠券, 我的收藏, 财务系统(包括我的钱包, 订单管理, 发票管理), 账号设置(基本资料, 我的邀请)
  {
    classIcon: 'iconicon_left_zhanghaosz',
    key: 'organizer-personalCenter',
    text: '个人中心',
    children: [
      {
        href: '/organizer/myCoupons',
        key: 'organizer-my-coupons',
        text: '我的优惠券',
      },
      {
        href: '/organizer/keep',
        key: 'organizer-keep',
        text: '我的收藏',
      },
      {
        href: '/organizer/companiesToWatch',
        key: 'organizer-companiesToWatch',
        text: '关注的企业',
      },
      {
        href: '/organizer/account',
        key: 'organizer-finance',
        text: '财务中心',
        children: [
          {
            href: '/organizer/account',
            key: 'organizer-account',
            text: '我的钱包',
          },
          {
            href: '/organizer/order',
            key: 'organizer-order',
            text: '订单管理',
          },
          {
            href: '/organizer/invoice',
            key: 'organizer-invoice',
            text: '发票管理',
          },
        ],
      },
      {
        href: '/organizer/basicInfo',
        key: 'organizer-basicInfo',
        text: '账号设置',
        children: [
          {
            href: '/organizer/basicInfo',
            key: 'organizer-basicInfo',
            text: '基本资料',
          },
          // {
          //   href: '/organizer/basicInfo/myInvite',
          //   key: 'organizer-basicInfo-myInvite',
          //   text: '我的邀请',
          // },
        ],
      },
    ],
  },
]
// 参展商菜单
export const exhibitor = [
  {
    classIcon: 'iconicon_left_home',
    href: '/exhibitor',
    key: 'exhibitor',
    text: '首页',
  },
  {
    href: '/exhibitor/cces',
    classIcon: 'iconicon_left_qiyeyz',
    key: 'exhibitor-cces',
    text: '企业云展系统',
    children: [
      {
        href: '/exhibitor/cces/cloud',
        key: 'exhibitor-cces-cloud',
        text: '我的云企业',
      },
      {
        href: '/exhibitor/cces/roaming',
        key: 'exhibitor-cces-roaming',
        text: '企业漫游',
      },
      {
        href: '/exhibitor/product',
        key: 'exhibitor-product',
        text: '产品服务',
      },
      {
        href: '/exhibitor/cces/dynamic',
        key: 'exhibitor-cces-dynamic',
        text: '我的企业动态',
      },
      {
        attr: cloudUrl,
        key: 'exhibitor-cloudDisk',
        text: '企业资料库',
      },
      // 云展访问数据
      {
        href: '/exhibitor/data',
        key: 'exhibitor-data',
        text: '云展访问数据',
      },
    ],
  },
  // Ai智能名片, 下面有我的名片, 通讯录
  {
    text: 'AI智能名片',
    classIcon: 'iconicon_left_wodemp',
    children: [
      {
        href: '/exhibitor/card',
        key: 'exhibitor-card',
        text: '我的名片',
      },
      {
        href: '/exhibitor/cardAddressBook',
        key: 'exhibitor-cardAddressBook',
        text: '通讯录',
      },
    ],
  },
  // 客户邀约模块, 原本叫大数据获客
  {
    href: '/exhibitor/dataMarketing',
    classIcon: 'iconicon_left_dashuj',
    key: 'exhibitor-dataMarketing',
    text: '客户邀约',
    children: [
      {
        href: '/exhibitor/dataMarketing/aiCall',
        key: 'exhibitor-dataMarketing-aiCall',
        text: '外呼呼叫',
        children: [
          {
            text: '智能任务',
            href: '/exhibitor/dataMarketing/aiCall',
            key: 'exhibitor-dataMarketing-aiCall',
          },
          {
            text: '话术管理',
            href: '/exhibitor/dataMarketing/aiCall/words',
            key: 'exhibitor-dataMarketing-aiCall-words',
          },
          {
            text: '外呼任务管理',
            href: '/exhibitor/dataMarketing/aiCall/task',
            key: 'exhibitor-dataMarketing-aiCall-task',
          },
          {
            text: '呼叫记录',
            href: '/exhibitor/dataMarketing/aiCall/record',
            key: 'exhibitor-dataMarketing-aiCall-record',
          },
        ],
      },
      {
        href: '/exhibitor/dataMarketing/preciseInvitation/china',
        key: 'exhibitor-dataMarketing-preciseInvitation-home-china',
        text: '短信邀约',
        children: [
          // 邀约模板, 邀约记录, 链接管理
          {
            href: '/exhibitor/dataMarketing/preciseInvitation/template/china',
            key: 'exhibitor-dataMarketing-preciseInvitation-home-china',
            text: '邀约模板',
          },
          {
            href: '/exhibitor/dataMarketing/preciseInvitation/record/china',
            key: 'exhibitor-dataMarketing-preciseInvitation-home-china-record',
            text: '邀约记录',
          },
          // {
          //   href: '/exhibitor/dataMarketing/preciseInvitation/link/china',
          //   key: 'exhibitor-dataMarketing-preciseInvitation-home-china-link',
          //   text: '链接管理',
          // },
        ],
      },
      {
        href: '/exhibitor/dataMarketing/preciseInvitation/international',
        key: 'exhibitor-dataMarketing-preciseInvitation-home-international',
        text: '邮件邀约',
        children: [
          // 邀约模板, 邀约记录, 链接管理
          {
            href: '/exhibitor/dataMarketing/preciseInvitation/template/international',
            key: 'exhibitor-dataMarketing-preciseInvitation-home-international',
            text: '邀约模板',
          },
          {
            href: '/exhibitor/dataMarketing/preciseInvitation/record/international',
            key: 'exhibitor-dataMarketing-preciseInvitation-home-international-record',
            text: '邀约记录',
          },
          // {
          //   href: '/exhibitor/dataMarketing/preciseInvitation/link/international',
          //   key: 'exhibitor-dataMarketing-preciseInvitation-home-international-link',
          //   text: '链接管理',
          // },
        ],
      },
      // {
      //   href: '/exhibitor/dataMarketing/invite',
      //   key: 'exhibitor-dataMarketing-invite',
      //   text: '精准邀约'
      // },
      // {
      //   href: '/exhibitor/dataMarketing/addressBook',
      //   key: 'exhibitor-dataMarketing-addressBook',
      //   text: '客户库',
      // },
      // {
      //   href: '/exhibitor/dataMarketing/cloudData',
      //   key: 'exhibitor-dataMarketing-cloudData',
      //   text: '云数据'
      // }
    ],
  },
  {
    classIcon: 'iconicon_left_kehugl',
    key: 'exhibitor-customerManagement',
    text: '客户管理系统',
    children: [
      // {
      //   href: '/exhibitor/cces/count/subAccount',
      //   key: 'exhibitor-cces-count-subAccount',
      //   text: '企业数据',
      // },
      {
        href: '/exhibitor/cces/count/customerDatabase',
        key: 'exhibitor-cces-count-customerDatabase',
        text: '企业客户库',
      },
      {
        href: '/exhibitor/cces/count/myCustomerDatabase',
        key: 'exhibitor-cces-count-myCustomerDatabase',
        text: '我的客户库',
      },
      {
        attr: cloudDataUrl,
        key: 'exhibitor-cloudData',
        text: '云数据',
      },
      // {
      //   href: '/exhibitor/data',
      //   key: 'exhibitor-data',
      //   text: '我的客户数据',
      // },
      // {
    ],
  },
  // 业务中心, 包括招商招标系统, 采购系统, 云上展览系统, 获客工具
  {
    icon: 'block',
    key: 'exhibitor-businessCenter',
    text: '业务中心',
    children: [
      {
        href: '/exhibitor/bidding',
        key: 'exhibitor-bidding',
        text: '招商招标系统',
        children: [
          {
            href: '/exhibitor/bidding',
            key: 'exhibitor-bidding',
            text: '云招标管理',
          },
          {
            href: '/exhibitor/merchants',
            key: 'exhibitor-merchants',
            text: '云招商管理',
          },
        ],
      },
      {
        href: '/exhibitor/procurement/cloud',
        key: 'exhibitor-procurement',
        text: '采购系统',
        children: [
          {
            href: '/exhibitor/procurement/cloud/opportunities',
            key: 'exhibitor-procurement-opportunities',
            text: '采购商机',
          },
          {
            href: '/exhibitor/procurement/customer',
            key: 'exhibitor-procurement-customer',
            text: '客户采购单',
          },
          {
            href: '/exhibitor/procurement/cloud',
            key: 'exhibitor-procurement-cloud',
            text: '我的采购',
          },
          {
            href: '/exhibitor/procurement/self',
            key: 'exhibitor-procurement-self',
            text: '我的采购单',
          },
        ],
      },
      {
        // href: '/exhibitor/cloudExhibit',
        key: 'exhibitor-cloudExhibit',
        text: '云上展览系统',
        children: [
          {
            href: '/exhibitor/myExhibit/exhibitSignup',
            key: 'exhibitor-myExhibit-exhibitSignup',
            text: '参展报名',
          },
        ],
      },
    ],
  },
  // 获客工具, 包括云头条,云优惠,我的直播,我的展览,我的会议
  {
    classIcon: 'iconicon_left_huoke',
    key: 'exhibitor-customerTool',
    text: '获客工具',
    children: [
      {
        href: '/exhibitor/cces/recruit',
        key: 'exhibitor-cces-recruit',
        text: '云招聘',
      },
      {
        href: '/exhibitor/information',
        key: 'exhibitor-information',
        text: '云头条',
      },
      {
        href: '/exhibitor/cces/offers',
        key: 'exhibitor-cces-offers',
        text: '云优惠',
      },
      // {
      //   href: '/exhibitor/myCoupons',
      //   key: 'exhibitor-my-coupons',
      //   text: '我的优惠券',
      // },
      {
        href: '/exhibitor/poster/poster',
        icon: 'picture',
        key: 'exhibitor-poster-poster',
        text: '云海报',
      },
      {
        href: '/exhibitor/myLive',
        icon: 'play-circle',
        key: 'exhibitor-myLive',
        text: '我的直播',
      },
      {
        // href: '/exhibitor/myExhibit',
        icon: 'appstore',
        key: 'exhibitor-myExhibit',
        text: '我的展览',
        children: [
          {
            // specialState: 'isShowUpdate',
            href: '/exhibitor/myExhibit/visitSignup',
            key: 'exhibitor-myExhibit-visitSignup',
            text: '参观报名',
          },
          {
            // specialState: 'isShowUpdate',
            href: '/exhibitor/myExhibit/buildSignup',
            key: 'exhibitor-myExhibit-buildSignup',
            text: '展厅搭建报名',
          },
        ],
      },
      {
        // href: '/exhibitor/myMeeting',
        icon: 'laptop',
        key: 'exhibitor-myMeeting',
        text: '我的会议',
        children: [
          {
            // specialState: 'isShowUpdate',
            href: '/exhibitor/myMeeting/join',
            key: 'exhibitor-myMeeting-join',
            text: '参加报名',
          },
          {
            // specialState: 'isShowUpdate',
            href: '/exhibitor/myMeeting/sponsor',
            key: 'exhibitor-myMeeting-sponsor',
            text: '会议赞助',
          },
        ],
      },
    ],
  },
  // 员工管理, 包括子账号管理和员工分享数据
  {
    icon: 'solution',
    key: 'exhibitor-employeeManagement',
    text: '员工管理',
    children: [
      {
        href: '/exhibitor/ram',
        key: 'exhibitor-ram',
        text: '子账号管理',
      },
      {
        href: '/exhibitor/cces/count/staffManage',
        key: 'exhibitor-cces-count-staffManage',
        text: '员工分享数据',
      },
    ],
  },
  // 个人中心, 包括 我的优惠券, 我的收藏, 财务系统(包括我的钱包, 订单管理, 发票管理), 账号设置(基本资料, 我的邀请)
  {
    classIcon: 'iconicon_left_zhanghaosz',
    key: 'exhibitor-personalCenter',
    text: '个人中心',
    children: [
      {
        href: '/exhibitor/myCoupons',
        key: 'exhibitor-my-coupons',
        text: '我的优惠券',
      },
      {
        href: '/exhibitor/keep',
        key: 'exhibitor-keep',
        text: '我的收藏',
      },
      {
        href: '/exhibitor/companiesToWatch',
        key: 'exhibitor-companiesToWatch',
        text: '关注的企业',
      },
      {
        href: '/exhibitor/account',
        key: 'exhibitor-finance',
        text: '财务中心',
        children: [
          {
            href: '/exhibitor/account',
            key: 'exhibitor-account',
            text: '我的钱包',
          },
          {
            href: '/exhibitor/order',
            key: 'exhibitor-order',
            text: '订单管理',
          },
          {
            href: '/exhibitor/invoice',
            key: 'exhibitor-invoice',
            text: '发票管理',
          },
        ],
      },
      {
        href: '/exhibitor/basicInfo',
        key: 'exhibitor-basicInfo',
        text: '账号设置',
        children: [
          {
            href: '/exhibitor/basicInfo',
            key: 'exhibitor-basicInfo',
            text: '基本资料',
          },
          // {
          //   href: '/exhibitor/basicInfo/myInvite',
          //   key: 'exhibitor-basicInfo-myInvite',
          //   text: '我的邀请',
          // },
        ],
      },
    ],
  },
]

// 工程商菜单 contractors

export const contractors = [
  {
    classIcon: 'iconicon_left_home',
    href: '/contractors',
    key: 'contractors',
    text: '首页',
  },
  {
    href: '/contractors/cces',
    classIcon: 'iconicon_left_qiyeyz',
    key: 'contractors-cces',
    text: '企业云展系统',
    children: [
      {
        href: '/contractors/cces/cloud',
        key: 'contractors-cces-cloud',
        text: '我的云企业',
      },
      {
        href: '/contractors/cces/roaming',
        key: 'contractors-cces-roaming',
        text: '企业漫游',
      },
      // {
      //   href: '/contractors/product',
      //   key: 'contractors-product',
      //   text: '产品服务',
      // },
      {
        href: '/contractors/cces/dynamic',
        key: 'contractors-cces-dynamic',
        text: '我的企业动态',
      },
      {
        attr: cloudUrl,
        key: 'contractors-cloudDisk',
        text: '企业资料库',
      },
      // 云展访问数据
      {
        href: '/contractors/data',
        key: 'contractors-data',
        text: '云展访问数据',
      },
    ],
  },
  // Ai智能名片, 下面有我的名片, 通讯录
  {
    text: 'AI智能名片',
    classIcon: 'iconicon_left_wodemp',
    children: [
      {
        href: '/contractors/card',
        key: 'contractors-card',
        text: '我的名片',
      },
      {
        href: '/contractors/cardAddressBook',
        key: 'contractors-cardAddressBook',
        text: '通讯录',
      },
    ],
  },
  // 客户邀约模块, 原本叫大数据获客
  {
    classIcon: 'iconicon_left_wodemp',
    key: 'contractors-aiCard',
    text: 'AI智能名片',
    children: [
      {
        href: '/contractors/card',
        key: 'contractors-card',
        text: '我的名片',
      },
      {
        text: '通讯录',
        href: '/contractors/addressBook',
        key: 'contractors-addressBook',
      },
    ],
  },
  {
    href: '/contractors/dataMarketing',
    classIcon: 'iconicon_left_dashuj',
    key: 'contractors-dataMarketing',
    text: '客户邀约',
    children: [
      {
        href: '/contractors/dataMarketing/aiCall',
        key: 'contractors-dataMarketing-aiCall',
        text: '外呼呼叫',
        children: [
          {
            text: '智能任务',
            href: '/contractors/dataMarketing/aiCall',
            key: 'contractors-dataMarketing-aiCall',
          },
          {
            text: '话术管理',
            href: '/contractors/dataMarketing/aiCall/words',
            key: 'contractors-dataMarketing-aiCall-words',
          },
          {
            text: '外呼任务管理',
            href: '/contractors/dataMarketing/aiCall/task',
            key: 'contractors-dataMarketing-aiCall-task',
          },
          {
            text: '呼叫记录',
            href: '/contractors/dataMarketing/aiCall/record',
            key: 'contractors-dataMarketing-aiCall-record',
          },
        ],
      },
      {
        href: '/contractors/dataMarketing/preciseInvitation/china',
        key: 'contractors-dataMarketing-preciseInvitation-home-china',
        text: '短信邀约',
      },
      {
        href: '/contractors/dataMarketing/preciseInvitation/international',
        key: 'contractors-dataMarketing-preciseInvitation-home-international',
        text: '邮件邀约',
      },
      // {
      //   href: '/contractors/dataMarketing/invite',
      //   key: 'contractors-dataMarketing-invite',
      //   text: '精准邀约'
      // },
      // {
      //   href: '/contractors/dataMarketing/addressBook',
      //   key: 'contractors-dataMarketing-addressBook',
      //   text: '客户库',
      // },
      // {
      //   href: '/contractors/dataMarketing/cloudData',
      //   key: 'contractors-dataMarketing-cloudData',
      //   text: '云数据'
      // }
    ],
  },
  {
    classIcon: 'iconicon_left_kehugl',
    key: 'contractors-customerManagement',
    text: '客户管理系统',
    children: [
      // {
      //   href: '/contractors/cces/count/subAccount',
      //   key: 'contractors-cces-count-subAccount',
      //   text: '企业数据',
      // },
      {
        href: '/contractors/cces/count/customerDatabase',
        key: 'contractors-cces-count-customerDatabase',
        text: '企业客户库',
      },
      {
        href: '/contractors/cces/count/myCustomerDatabase',
        key: 'contractors-cces-count-myCustomerDatabase',
        text: '我的客户库',
      },
      {
        attr: cloudDataUrl,
        key: 'contractors-cloudData',
        text: '云数据',
      },
      // {
      //   href: '/contractors/data',
      //   key: 'contractors-data',
      //   text: '我的客户数据',
      // },
      // {
    ],
  },
  // 业务中心, 包括招商招标系统, 采购系统, 云上展览系统, 获客工具
  {
    icon: 'block',
    key: 'contractors-businessCenter',
    text: '业务中心',
    children: [
      {
        href: '/contractors/bidding',
        key: 'contractors-bidding',
        text: '招商招标系统',
        children: [
          {
            href: '/contractors/bidding',
            key: 'contractors-bidding',
            text: '云招标管理',
          },
          {
            href: '/contractors/merchants',
            key: 'contractors-merchants',
            text: '云招商管理',
          },
        ],
      },
      {
        href: '/contractors/procurement/cloud',
        key: 'contractors-procurement',
        text: '采购系统',
        children: [
          {
            href: '/contractors/procurement/cloud/opportunities',
            key: 'contractors-procurement-opportunities',
            text: '采购商机',
          },
          // {
          //   href: '/contractors/procurement/customer',
          //   key: 'contractors-procurement-customer',
          //   text: '客户采购单',
          // },
          {
            href: '/contractors/procurement/cloud',
            key: 'contractors-procurement-cloud',
            text: '我的采购',
          },
          {
            href: '/contractors/procurement/self',
            key: 'contractors-procurement-self',
            text: '我的采购单',
          },
        ],
      },
      // {
      //   // href: '/contractors/cloudExhibit',
      //   key: 'contractors-cloudExhibit',
      //   text: '云上展览系统',
      //   children: [
      //     {
      //       href: '/contractors/myExhibit/exhibitSignup',
      //       key: 'contractors-myExhibit-exhibitSignup',
      //       text: '参展报名',
      //     },
      //   ],
      // },
    ],
  },
  // 获客工具, 包括云头条,云优惠,我的直播,我的展览,我的会议
  {
    classIcon: 'iconicon_left_huoke',
    key: 'contractors-customerTool',
    text: '获客工具',
    children: [
      {
        href: '/contractors/cces/recruit',
        key: 'contractors-cces-recruit',
        text: '云招聘',
      },
      {
        href: '/contractors/information',
        key: 'contractors-information',
        text: '云头条',
      },
      {
        href: '/contractors/cces/offers',
        key: 'contractors-cces-offers',
        text: '云优惠',
      },
      // {
      //   href: '/contractors/myCoupons',
      //   key: 'contractors-my-coupons',
      //   text: '我的优惠券',
      // },
      {
        href: '/contractors/poster/poster',
        icon: 'picture',
        key: 'contractors-poster-poster',
        text: '云海报',
      },
      {
        href: '/contractors/myLive',
        icon: 'play-circle',
        key: 'contractors-myLive',
        text: '我的直播',
      },
      {
        // href: '/contractors/myExhibit',
        icon: 'appstore',
        key: 'contractors-myExhibit',
        text: '我的展览',
        children: [
          {
            // specialState: 'isShowUpdate',
            href: '/contractors/myExhibit/visitSignup',
            key: 'contractors-myExhibit-visitSignup',
            text: '参观报名',
          },
          {
            // specialState: 'isShowUpdate',
            href: '/contractors/myExhibit/buildSignup',
            key: 'contractors-myExhibit-buildSignup',
            text: '展厅搭建报名',
          },
        ],
      },
      {
        // href: '/contractors/myMeeting',
        icon: 'laptop',
        key: 'contractors-myMeeting',
        text: '我的会议',
        children: [
          {
            // specialState: 'isShowUpdate',
            href: '/contractors/myMeeting/join',
            key: 'contractors-myMeeting-join',
            text: '参加报名',
          },
          {
            // specialState: 'isShowUpdate',
            href: '/contractors/myMeeting/sponsor',
            key: 'contractors-myMeeting-sponsor',
            text: '会议赞助',
          },
        ],
      },
    ],
  },
  // 员工管理, 包括子账号管理和员工分享数据
  {
    icon: 'solution',
    key: 'contractors-employeeManagement',
    text: '员工管理',
    children: [
      {
        href: '/contractors/ram',
        key: 'contractors-ram',
        text: '子账号管理',
      },
      {
        href: '/contractors/cces/count/staffManage',
        key: 'contractors-cces-count-staffManage',
        text: '员工分享数据',
      },
    ],
  },
  // 个人中心, 包括 我的优惠券, 我的收藏, 财务系统(包括我的钱包, 订单管理, 发票管理), 账号设置(基本资料, 我的邀请)
  {
    classIcon: 'iconicon_left_zhanghaosz',
    key: 'contractors-personalCenter',
    text: '个人中心',
    children: [
      {
        href: '/contractors/myCoupons',
        key: 'contractors-my-coupons',
        text: '我的优惠券',
      },
      {
        href: '/contractors/keep',
        key: 'contractors-keep',
        text: '我的收藏',
      },
      {
        href: '/contractors/companiesToWatch',
        key: 'contractors-companiesToWatch',
        text: '关注的企业',
      },
      {
        href: '/contractors/account',
        key: 'contractors-finance',
        text: '财务中心',
        children: [
          {
            href: '/contractors/account',
            key: 'contractors-account',
            text: '我的钱包',
          },
          {
            href: '/contractors/order',
            key: 'contractors-order',
            text: '订单管理',
          },
          {
            href: '/contractors/invoice',
            key: 'contractors-invoice',
            text: '发票管理',
          },
        ],
      },
      {
        href: '/contractors/basicInfo',
        key: 'contractors-basicInfo',
        text: '账号设置',
        children: [
          {
            href: '/contractors/basicInfo',
            key: 'contractors-basicInfo',
            text: '基本资料',
          },
          // {
          //   href: '/contractors/basicInfo/myInvite',
          //   key: 'contractors-basicInfo-myInvite',
          //   text: '我的邀请',
          // },
        ],
      },
    ],
  },
]

// 设计师菜单
export const designer = [
  {
    classIcon: 'iconicon_left_home',
    href: '/designer',
    key: 'designer',
    text: '首页',
  },
  {
    href: '/designer/cces',
    classIcon: 'iconicon_left_qiyeyz',
    key: 'designer-cces',
    text: '企业云展系统',
    children: [
      {
        href: '/designer/cces/cloud',
        key: 'designer-cces-cloud',
        text: '我的云企业',
      },
      {
        href: '/designer/cces/roaming',
        key: 'designer-cces-roaming',
        text: '企业漫游',
      },
      // {
      //   href: '/designer/product',
      //   key: 'designer-product',
      //   text: '产品服务',
      // },
      {
        href: '/designer/cces/dynamic',
        key: 'designer-cces-dynamic',
        text: '我的企业动态',
      },
      {
        attr: cloudUrl,
        key: 'designer-cloudDisk',
        text: '企业资料库',
      },
      // 云展访问数据
      {
        href: '/designer/data',
        key: 'designer-data',
        text: '云展访问数据',
      },
    ],
  },
  // Ai智能名片, 下面有我的名片, 通讯录
  {
    text: 'AI智能名片',
    classIcon: 'iconicon_left_wodemp',
    children: [
      {
        href: '/designer/card',
        key: 'designer-card',
        text: '我的名片',
      },
      {
        href: '/designer/cardAddressBook',
        key: 'designer-cardAddressBook',
        text: '通讯录',
      },
    ],
  },
  // 客户邀约模块, 原本叫大数据获客
  {
    href: '/designer/dataMarketing',
    classIcon: 'iconicon_left_dashuj',
    key: 'designer-dataMarketing',
    text: '客户邀约',
    children: [
      {
        href: '/designer/dataMarketing/aiCall',
        key: 'designer-dataMarketing-aiCall',
        text: '外呼呼叫',
        children: [
          {
            text: '智能任务',
            href: '/designer/dataMarketing/aiCall',
            key: 'designer-dataMarketing-aiCall',
          },
          {
            text: '话术管理',
            href: '/designer/dataMarketing/aiCall/words',
            key: 'designer-dataMarketing-aiCall-words',
          },
          {
            text: '外呼任务管理',
            href: '/designer/dataMarketing/aiCall/task',
            key: 'designer-dataMarketing-aiCall-task',
          },
          {
            text: '呼叫记录',
            href: '/designer/dataMarketing/aiCall/record',
            key: 'designer-dataMarketing-aiCall-record',
          },
        ],
      },
      {
        href: '/designer/dataMarketing/preciseInvitation/china',
        key: 'designer-dataMarketing-preciseInvitation-home-china',
        text: '短信邀约',
      },
      {
        href: '/designer/dataMarketing/preciseInvitation/international',
        key: 'designer-dataMarketing-preciseInvitation-home-international',
        text: '邮件邀约',
      },
      // {
      //   href: '/designer/dataMarketing/invite',
      //   key: 'designer-dataMarketing-invite',
      //   text: '精准邀约'
      // },
      // {
      //   href: '/designer/dataMarketing/addressBook',
      //   key: 'designer-dataMarketing-addressBook',
      //   text: '客户库',
      // },
      // {
      //   href: '/designer/dataMarketing/cloudData',
      //   key: 'designer-dataMarketing-cloudData',
      //   text: '云数据'
      // }
    ],
  },
  {
    classIcon: 'iconicon_left_kehugl',
    key: 'designer-customerManagement',
    text: '客户管理系统',
    children: [
      // {
      //   href: '/designer/cces/count/subAccount',
      //   key: 'designer-cces-count-subAccount',
      //   text: '企业数据',
      // },
      {
        href: '/designer/cces/count/customerDatabase',
        key: 'designer-cces-count-customerDatabase',
        text: '企业客户库',
      },
      {
        href: '/designer/cces/count/myCustomerDatabase',
        key: 'designer-cces-count-myCustomerDatabase',
        text: '我的客户库',
      },
      {
        attr: cloudDataUrl,
        key: 'designer-cloudData',
        text: '云数据',
      },
      // {
      //   href: '/designer/data',
      //   key: 'designer-data',
      //   text: '我的客户数据',
      // },
      // {
    ],
  },
  // 业务中心, 包括招商招标系统, 采购系统, 云上展览系统, 获客工具
  {
    icon: 'block',
    key: 'designer-businessCenter',
    text: '业务中心',
    children: [
      {
        href: '/designer/bidding',
        key: 'designer-bidding',
        text: '招商招标系统',
        children: [
          {
            href: '/designer/bidding',
            key: 'designer-bidding',
            text: '云招标管理',
          },
          {
            href: '/designer/merchants',
            key: 'designer-merchants',
            text: '云招商管理',
          },
        ],
      },
      {
        href: '/designer/procurement/cloud',
        key: 'designer-procurement',
        text: '采购系统',
        children: [
          {
            href: '/designer/procurement/cloud/opportunities',
            key: 'designer-procurement-opportunities',
            text: '采购商机',
          },
          // {
          //   href: '/designer/procurement/customer',
          //   key: 'designer-procurement-customer',
          //   text: '客户采购单',
          // },
          {
            href: '/designer/procurement/cloud',
            key: 'designer-procurement-cloud',
            text: '我的采购',
          },
          {
            href: '/designer/procurement/self',
            key: 'designer-procurement-self',
            text: '我的采购单',
          },
        ],
      },
      // {
      //   // href: '/designer/cloudExhibit',
      //   key: 'designer-cloudExhibit',
      //   text: '云上展览系统',
      //   children: [
      //     {
      //       href: '/designer/myExhibit/exhibitSignup',
      //       key: 'designer-myExhibit-exhibitSignup',
      //       text: '参展报名',
      //     },
      //   ],
      // },
    ],
  },
  // 获客工具, 包括云头条,云优惠,我的直播,我的展览,我的会议
  {
    classIcon: 'iconicon_left_huoke',
    key: 'designer-customerTool',
    text: '获客工具',
    children: [
      {
        href: '/designer/cces/recruit',
        key: 'designer-cces-recruit',
        text: '云招聘',
      },
      {
        href: '/designer/information',
        key: 'designer-information',
        text: '云头条',
      },
      {
        href: '/designer/cces/offers',
        key: 'designer-cces-offers',
        text: '云优惠',
      },

      {
        href: '/designer/poster/poster',
        icon: 'picture',
        key: 'designer-poster-poster',
        text: '云海报',
      },
      {
        href: '/designer/myLive',
        icon: 'play-circle',
        key: 'designer-myLive',
        text: '我的直播',
      },
      {
        // href: '/designer/myExhibit',
        icon: 'appstore',
        key: 'designer-myExhibit',
        text: '我的展览',
        children: [
          {
            // specialState: 'isShowUpdate',
            href: '/designer/myExhibit/visitSignup',
            key: 'designer-myExhibit-visitSignup',
            text: '参观报名',
          },
          {
            // specialState: 'isShowUpdate',
            href: '/designer/myExhibit/buildSignup',
            key: 'designer-myExhibit-buildSignup',
            text: '展厅搭建报名',
          },
        ],
      },
      {
        // href: '/designer/myMeeting',
        icon: 'laptop',
        key: 'designer-myMeeting',
        text: '我的会议',
        children: [
          {
            // specialState: 'isShowUpdate',
            href: '/designer/myMeeting/join',
            key: 'designer-myMeeting-join',
            text: '参加报名',
          },
          {
            // specialState: 'isShowUpdate',
            href: '/designer/myMeeting/sponsor',
            key: 'designer-myMeeting-sponsor',
            text: '会议赞助',
          },
        ],
      },
    ],
  },
  // 员工管理, 包括子账号管理和员工分享数据
  {
    icon: 'solution',
    key: 'designer-employeeManagement',
    text: '员工管理',
    children: [
      {
        href: '/designer/ram',
        key: 'designer-ram',
        text: '子账号管理',
      },
      {
        href: '/designer/cces/count/staffManage',
        key: 'designer-cces-count-staffManage',
        text: '员工分享数据',
      },
    ],
  },
  // 个人中心, 包括 我的优惠券, 我的收藏, 财务系统(包括我的钱包, 订单管理, 发票管理), 账号设置(基本资料, 我的邀请)
  {
    classIcon: 'iconicon_left_zhanghaosz',
    key: 'designer-personalCenter',
    text: '个人中心',
    children: [
      {
        href: '/designer/myCoupons',
        key: 'designer-my-coupons',
        text: '我的优惠券',
      },
      {
        href: '/designer/keep',
        key: 'designer-keep',
        text: '我的收藏',
      },
      {
        href: '/designer/companiesToWatch',
        key: 'designer-companiesToWatch',
        text: '关注的企业',
      },
      {
        href: '/designer/account',
        key: 'designer-finance',
        text: '财务中心',
        children: [
          {
            href: '/designer/account',
            key: 'designer-account',
            text: '我的钱包',
          },
          {
            href: '/designer/order',
            key: 'designer-order',
            text: '订单管理',
          },
          {
            href: '/designer/invoice',
            key: 'designer-invoice',
            text: '发票管理',
          },
        ],
      },
      {
        href: '/designer/basicInfo',
        key: 'designer-basicInfo',
        text: '账号设置',
        children: [
          {
            href: '/designer/basicInfo',
            key: 'designer-basicInfo',
            text: '基本资料',
          },
          // {
          //   href: '/designer/basicInfo/myInvite',
          //   key: 'designer-basicInfo-myInvite',
          //   text: '我的邀请',
          // },
        ],
      },
    ],
  },
]
